import Button from "../../../Components/Button/Button";
import CardHeader from "../../../Components/Card/CardHeader";
import Input from "../../../Components/Input/Input";
import RequestFooter from "../../../Components/RequestFooter/RequestFooter";
import Select from "../../../Components/Select/Select";
import TextArea from "../../../Components/TextArea/TextArea";
import styles from "./request.create.module.css"
import plus from "../../../icons/plus-violet.svg"
import Modal from "../../../Components/Modal/Modal";
import avatar from "../../../images/Avatar_2.svg"
import avatarBuilding from "../../../images/Avatar_building.svg"
import React, { useContext, useEffect, useState, useTransition } from "react";
import checkEmpty from "../../../images/Check_Empty.svg"
import checkFilled from "../../../images/Check.svg"
import SmallCard from "../../../Components/SmallCard/SmallCard";
import Check from "../../../Components/Check/Check";
import regTypesData from "./regTypesData.json";
import { Outlet, useNavigate, useOutletContext, useParams } from "react-router-dom";
import Dropdown from "../../../Components/Dropdown/Dropdown";
import ModalCenter from "../../../Components/ModalCenter/ModalCenter";
import pdfIcon from "../../../icons/PdfIcon.svg"
import uploadIcon from "../../../icons/upload-icon.svg"
import EmptyBlock from "../../../Components/EmptyBlock/EmptyBlock";
import FileInput from "../../../Components/FileInput/FileInput";
import CardContainer from "../../../Components/Card/CardContainer";
import CardBody from "../../../Components/Card/CardBody";
import ObjectModal from "../../Object/ObjectModal/ObjectModal";
import DocumentModal from "../../Document/DocumentModal";
import useRequestContext from "../useRequestContext";
import { mimeTypes } from "../../../constants/constants";

export default function CreateRequest() {
    const [isBuildingsOpen, setBuildingsOpen] = useState(false)
    const navigate = useNavigate();
    const { request, regTypes, rightTypes, setRequest, getRequests, saveDocument, documentTypes, requestStatuses, deleteDocument, status, deleteParticipant, objectTypes, addFlSubject, addFlSubjectWithAgent, generateStatement, createRequest, addUlAgent, id, isDisabled, addSignature, addUlRepresentingFl, sendStatement, addDocumentParticipant } = useRequestContext();
    const [isDocumentModal, setDocumentModal] = useState(false)
    const [uploadedDocument, setUploadedDocument] = useState(null)
    const removeDocument = (id) => {
        deleteDocument(id).then(x => {
            const newState = request.Documents.filter(t => t.Id != id);
            setRequest({ ...request, Documents: newState })
        })
    }
   
    useEffect(() => {
        const type = regTypesData.find(x => x.code === request?.RegAction.code)
        if (!isNaN(id)) {
            navigate(type?.path.replace(":id", id))
        }
        console.log(type)
    }, [request?.RegAction.code,id])


    const selectRegType = (regTypeCode) => {
        const regType = regTypes.find(t => t.code == regTypeCode)
        setRequest({ ...request, RegAction: regType })
    }


    return (<div className={styles.container}>

        <CardContainer>
            <CardHeader title="Тип регистрационного действия"></CardHeader>
            <CardBody>
                <Select disabled={isDisabled} value={request?.RegAction.code} onChange={(e) => selectRegType(e)}>
                    {regTypes.map((x) =>
                        <option value={x.code}>{x.name}</option>
                    )}
                </Select>
                {request?.RegAction?.code === 5 &&
                    <Select disabled={isDisabled} label="Тип права" value={request?.RightType?.code} onChange={(value) => setRequest({ ...request, RightType: { ...request?.RightType, code: value } })} placeholder="Выберите тип права">
                        {rightTypes.map((x) =>
                            <option value={x.code}>{x.name}</option>

                        )}

                    </Select>
                }
                {isNaN(id) &&
                    <Button large type="primary" text="Создать заявление" onClick={() => createRequest(request?.RegAction.code, request?.RightType?.code).then(x => navigate(`/request/edit/${x.data}`))}></Button>
                }
                {!isNaN(id) &&
                    <React.Fragment>
                        {request?.RegAction?.code != 5 &&
                            <Select label="В кредит" disabled={isDisabled} value={request?.IsMortgage} onChange={(value) => setRequest({ ...request, IsMortgage: value })}>
                                <option value={true}>Да</option>
                                <option value={false}>Нет</option>
                            </Select>
                        }
                        {request?.IsMortgage &&
                            <Input label="Сумма кредита" value={request.SummCredit} onChange={(value) => setRequest({ ...request, SummCredit: value })} mask={Number}></Input>

                        }
                    </React.Fragment>
                }
            </CardBody>
        </CardContainer>
        {!isNaN(id) &&
            <CardContainer >
                <CardHeader title="Объект недвижимости"></CardHeader>
                <CardBody>
                    {
                        (request?.Object != null && request?.RegAction?.code != 1) &&
                        <SmallCard onClick={isDisabled ? console.log("Заявка уже отправлена") : () => setBuildingsOpen(true)} type="default" title={request?.Object?.Address?.Note} subtitle={`${request?.Object?.Type?.name}, ${request?.Object?.CadNum}`} avatar={avatarBuilding}></SmallCard>
                    }
                    {
                        (request?.Object != null && request?.RegAction?.code === 1) &&
                        <SmallCard onClick={() => setBuildingsOpen(true)} type="default" title={`ЖК ${request?.Object?.Complex.name}, ${request?.Object?.House.name}`} subtitle={`${request?.Object?.Type.name}, ${request?.Object?.CondCadNum}`} avatar={avatarBuilding}></SmallCard>
                    }
                    {(request?.Object == null && !isDisabled) &&
                        <React.Fragment>
                            <EmptyBlock title="Объекты недвижимости" />
                            <Button type="primary" text="Добавить объект недвижимости" large onClick={() => setBuildingsOpen(true)} icon={plus}></Button>
                        </React.Fragment>

                    }

                </CardBody>
            </CardContainer>
        }
        <Outlet context={[request, regTypes, rightTypes, setRequest, getRequests, saveDocument, documentTypes, requestStatuses, deleteDocument, status, deleteParticipant, objectTypes, addFlSubject, addFlSubjectWithAgent, generateStatement, createRequest, addUlAgent, id, isDisabled, addSignature, addUlRepresentingFl, sendStatement, addDocumentParticipant]} />
        {!isNaN(id) &&

            <CardContainer >
                <CardHeader title="Документы"></CardHeader>
                <CardBody>
                    {!isDisabled &&
                        <FileInput accept={[mimeTypes.Pdf, mimeTypes.Docx]} onClick={() => setDocumentModal(true)} onChange={(value) => setUploadedDocument(value)} />

                    }
                    {request?.Documents?.filter(x => !x.FileName.includes(".xml")).map((x) =>
                        <SmallCard title={x.FileName} subtitle={`Тип документа: ${x.DocType.name}`} avatar={pdfIcon} onRemove={isDisabled ? null : () => removeDocument(x.Id)} type="default" />

                    )}
                    {
                        request?.Documents?.filter(x => !x.FileName.includes(".xml")).length == 0 &&
                        <EmptyBlock title="Текущие документы"></EmptyBlock>
                    }
                </CardBody>
            </CardContainer>
        }
        {(!isNaN(id) && !isDisabled) &&
            <CardContainer>
                <CardHeader title="Дополнительная информация"></CardHeader>
                <CardBody>
                    <TextArea value={request?.Note} onChange={(value) => setRequest({ ...request, Note: value })} label="Комментарий" placeholder="Комментарий"></TextArea>
                    {/* <Input placeholder="admin@signself.ru" label="Отправить результат на email" subLabel="Укажите электронную почту банка для отправки результата регистрации (для раскрытия аккредитива)"></Input> */}
                </CardBody>
            </CardContainer>


        }
        {!isNaN(id) &&
            <RequestFooter back={<Button text="Назад" href="/request/list"></Button>} next={<Button text="Подписать документы" href={`/request/signature/${request?.Id}`}></Button>} ></RequestFooter>

        }

        <ObjectModal objectTypes={objectTypes} request={request} setRequest={(value) => setRequest(value)} isOpen={isBuildingsOpen} setOpen={(e) => setBuildingsOpen(e)}></ObjectModal>
        <DocumentModal setRequest={setRequest} documentTypes={documentTypes} saveDocument={saveDocument} request={request} uploadedDocument={uploadedDocument} setUploadedDocument={(value) => setUploadedDocument(value)} isOpen={isDocumentModal} setOpen={(e) => setDocumentModal(e)}></DocumentModal>



        {/* <Modal title="Тип регистрационного действия" isOpen={regTypeModal} setOpen={(e) => setRegTypeModal(e)} >
            <Dropdown isShown title="Регистрация прав, ограничений (обременений) прав">
                <ul>
                    <li style={{ cursor: "pointer" }} onClick={(e) => { selectRegType(e); setRegTypeModal(false) }}>Регистрация договора купли-продажи (ДКП)</li>
                    <li style={{ cursor: "pointer" }} onClick={(e) => { selectRegType(e); setRegTypeModal(false) }}>Регистрация нового право (на АПП, на застройщика)</li>
                </ul>
            </Dropdown>
            <Dropdown isShown title="Регистрация сделок">
                <ul>
                    <li style={{ cursor: "pointer" }} onClick={(e) => { selectRegType(e); setRegTypeModal(false) }}>Регистрация ДДУ</li>
                    <li style={{ cursor: "pointer" }} onClick={(e) => { selectRegType(e); setRegTypeModal(false) }}>Регистрация соглашения об уступке требований по ДДУ !</li>
                    <li style={{ cursor: "pointer" }} onClick={(e) => { selectRegType(e); setRegTypeModal(false) }}>Регистрация дополнительного соглашения к ДДУ !</li>
                    <li style={{ cursor: "pointer" }} onClick={(e) => { selectRegType(e); setRegTypeModal(false) }}>Регистрация соглашения о расторжении ДДУ !</li>
                </ul>
            </Dropdown>
        </Modal> */}
    </div >)
}